import * as React from "react"
import { View, Text } from "react-native";
import * as styles from "./toast-style";
import { color } from "../../theme"

export interface ToastProps {
    text: string,
    type?: string
}

export function Toast(props: ToastProps){

    const generateBG = () => {
        const type = props.type || 'info';
        switch (type){
            case 'info':
                return color.accent;
            case 'error':
                return color.error;
            case 'warning':
                return color.palette.orange
        } 
        return color.accent;       
    }

    return (        
        <View style={styles.baseView}>
            <Text numberOfLines={1} style={{...styles.text, backgroundColor: generateBG()}}>
                {props.text}
            </Text>
        </View>
    )
}